import { paletteRebrand } from '../color/palette-rebrand';
import { newBrandFonts } from './fonts';
import { tokens } from './tokens';

// Widen literal string types so we can assign new values to slots that the
// default `tokens` typed as their exact literal (e.g. `'#000000'`).
type Widen<T> = T extends string | number ? string : { [K in keyof T]: Widen<T[K]> };

// Rebrand theme values. Same shape as `tokens` — only the keys we want to
// override differ; the rest mirror the default via spread. Applied inside the
// `rebrandTheme` className (see `vars.css.ts`).
export const rebrandTokens: Widen<typeof tokens> = {
  ...tokens,
  typography: {
    ...tokens.typography,
    headingFontFamily: newBrandFonts.antiqueLegacy.family,
  },
  shape: {
    button: {
      borderRadius: '999px',
    },
    dialog: {
      borderRadius: '24px',
      shadow: '0px 8px 36px rgba(0, 0, 0, 0.17)',
    },
  },
  color: {
    ...tokens.color,
    foreground: {
      ...tokens.color.foreground,
      contentPrimary: paletteRebrand.content.primary,
      contentSecondary: paletteRebrand.content.secondary,
      contentTertiary: paletteRebrand.content.tertiary,
      contentInverse: paletteRebrand.content.inversePrimary,
    },
    background: {
      ...tokens.color.background,
      surface: paletteRebrand.background.surface,
      cream: paletteRebrand.neutral[100],
      cardWhite: paletteRebrand.brand.cardWhite,
      // "Potential Pinq" — bright fuchsia used on the new business onboarding side panel.
      potentialPinq: '#F5A8CC',
      // Gold accent behind the ELC upsell pill + feature icons. Placeholder
      // name, pending design-system naming.
      placeholderKhaki: '#C0B77C',
    },
    border: {
      ...tokens.color.border,
      primary: paletteRebrand.border.primary,
      secondary: paletteRebrand.border.secondary,
      cream: '#E5E0D3',
    },
    brand: {
      luckyBreak: paletteRebrand.brand.luckyBreak,
      tenThousandCoffees: paletteRebrand.brand.tenThousandCoffees,
      cardWhite: paletteRebrand.brand.cardWhite,
    },
  },
};
